module.exports = __webpack_public_path__ + "static/media/rice.a3fb5ff2.png";